export default "/_next/static/media/Create-Group-398x1024.2c842374839134cf8f80393a0cd9b560.png";